/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiDocumentsDtoCompanyDocumentDto } from './WebApiDocumentsDtoCompanyDocumentDto';
import {
    WebApiDocumentsDtoCompanyDocumentDtoFromJSON,
    WebApiDocumentsDtoCompanyDocumentDtoFromJSONTyped,
    WebApiDocumentsDtoCompanyDocumentDtoToJSON,
} from './WebApiDocumentsDtoCompanyDocumentDto';

/**
 * 
 * @export
 * @interface WebApiDocumentsDtoCompanyDocumentListDto
 */
export interface WebApiDocumentsDtoCompanyDocumentListDto {
    /**
     * 
     * @type {Array<WebApiDocumentsDtoCompanyDocumentDto>}
     * @memberof WebApiDocumentsDtoCompanyDocumentListDto
     */
    documents?: Array<WebApiDocumentsDtoCompanyDocumentDto> | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiDocumentsDtoCompanyDocumentListDto
     */
    usedBytes?: number;
    /**
     * 
     * @type {number}
     * @memberof WebApiDocumentsDtoCompanyDocumentListDto
     */
    limitBytes?: number;
}

/**
 * Check if a given object implements the WebApiDocumentsDtoCompanyDocumentListDto interface.
 */
export function instanceOfWebApiDocumentsDtoCompanyDocumentListDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiDocumentsDtoCompanyDocumentListDtoFromJSON(json: any): WebApiDocumentsDtoCompanyDocumentListDto {
    return WebApiDocumentsDtoCompanyDocumentListDtoFromJSONTyped(json, false);
}

export function WebApiDocumentsDtoCompanyDocumentListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiDocumentsDtoCompanyDocumentListDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'documents': !exists(json, 'documents') ? undefined : (json['documents'] === null ? null : (json['documents'] as Array<any>).map(WebApiDocumentsDtoCompanyDocumentDtoFromJSON)),
        'usedBytes': !exists(json, 'usedBytes') ? undefined : json['usedBytes'],
        'limitBytes': !exists(json, 'limitBytes') ? undefined : json['limitBytes'],
    };
}

export function WebApiDocumentsDtoCompanyDocumentListDtoToJSON(value?: WebApiDocumentsDtoCompanyDocumentListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'documents': value.documents === undefined ? undefined : (value.documents === null ? null : (value.documents as Array<any>).map(WebApiDocumentsDtoCompanyDocumentDtoToJSON)),
        'usedBytes': value.usedBytes,
        'limitBytes': value.limitBytes,
    };
}

